import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=5e19d4c4&scope=true&lang=css"

const __exports__ = script;

export default __exports__